module.exports = __webpack_public_path__ + "static/aboleth-8c82b5742e27952d116a5882fe82e3fa.jpg";